<div class="campanha-roi-pipeline-widgets" *ngIf="roi">
    <div class="card card-widget card-widget-recursos">
        <div class="card-body">
            <div class="card-icon">
                <i [class]="KPI_RECURSOS.icon"></i>
            </div>

            <div class="card-titles">
                <h5 class="card-title" [style.color]="titleColor">
                    {{(roi?.valorTotalDespesas ? roi?.valorTotalDespesas : 0)| currencyFormat: 1:2:2}}
                </h5>
                <h6 class="card-subtitle" [style.color]="subTitleColor">
                    {{KPI_RECURSOS.name}}
                </h6>
            </div>
        </div>
    </div>

    <div class="card card-widget card-widget-resultado">
        <div class="card-body">
            <div class="card-icon">
                <i [class]="KPI_RESULTADO.icon" aria-hidden="true"></i>
            </div>
            
            <div class="card-titles">
                <h5 class="card-title" [style.color]="titleColor">
                    {{(roi?.valorTotalVendas ? roi.valorTotalVendas : 0)| currencyFormat: 1:2:2}}
                </h5>
                <h6 class="card-subtitle" [style.color]="subTitleColor">
                    {{KPI_RESULTADO.name}}
                </h6>
            </div>
        </div>
    </div> 
    
    <div class="card card-widget card-widget-roi {{KPI_ROI?.cssClass}}">
        <div class="card-body">
            <div class="card-icon">
                <i [class]="KPI_ROI?.icon"></i>
            </div>

            <div class="card-titles">
                <h5 class="card-title" [style.color]="titleColor">
                    {{(roi?.retornoEfetivo ? roi.retornoEfetivo : 0)| decimalFormat: 1:2:2}}x
                </h5>
                <h6 class="card-subtitle" [style.color]="subTitleColor">
                    {{KPI_ROI?.name}}
                </h6>
            </div>
        </div>
    </div> 
</div>